import { useEffect, useState } from 'react';
import { fetchClinics } from '@utils/fetch';
import { useGlobalPersistedStore } from 'app/stores/globalStore';
import { isEmpty } from 'lodash';

export const useInitializeClinics = () => {
  const { clinics, setClinics } = useGlobalPersistedStore(state => state);
  const [clinicsLoaded, setClinicsLoaded] = useState(false);

  useEffect(() => {
    const initClinics = async () => {
      try {
        const fetched = await fetchClinics();
        setClinics(fetched);
      } catch (error) {
        console.error('Failed to fetch clinics:', error);
      }
    };

    if (isEmpty(clinics) && !clinicsLoaded) {
      initClinics();
      setClinicsLoaded(true);
    }
  }, [clinics, clinicsLoaded, setClinics]);

  return { clinics };
};
